import axios from '../service/axios/axios'
export default {
  //获取订单记录列表
  getOrderList(data) {
    return axios({
      method: 'post',
      url: 'platform/order/getOrderList',
      data: data,
    })
  },
  //获取订单记录详情
  getOrderInfo({ order_id }) {
    return axios({
      method: 'post',
      url: 'platform/order/getOrderInfo',
      data: { order_id },
    })
  },
  //获取订单物流信息
  getOrderLogisticsInfo({ order_id }) {
    return axios({
      method: 'post',
      url: 'platform/order/getOrderLogisticsInfo',
      data: { order_id },
    })
  },
  //查看补发药品订单物流信息
  orderAgainExpress({ again_id }) {
    return axios({
      method: 'post',
      url: 'platform/order/orderAgainExpress',
      data: { again_id },
    })
  },
  //订单售后退款
  afterSalesrefund(data) {
    return axios({
      method: 'post',
      url: 'platform/order/afterSalesrefund',
      data: data,
    })
  },
  //获取售后退款验证码
  refundVerifiCode(data) {
    return axios({
      method: 'post',
      url: 'platform/order/refundVerifiCode',
      data: data,
    })
  },
  // 设置是否已开具发票
  setIsInvoice(data) {
    return axios({
      method: 'post',
      url: 'platform/Order/setIsInvoice',
      data: data,
    })
  },
}
